// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { useEffect, useRef } from "react"
import { subscribeAmyDataChanged } from "./amySync"

/**
 * Re-runs `refresh` whenever Amy completes a mutating tool (ADR-036 finding
 * 6) — so Today, Plan, ledger, and Goals views behind the chat sheet track
 * what Amy just changed instead of going stale until a manual reload.
 * The latest callback is kept in a ref so subscribers don't churn the
 * subscription on every render.
 */
export function useAmyDataRefresh(refresh: () => void): void {
  const refreshRef = useRef(refresh)
  refreshRef.current = refresh
  useEffect(() => subscribeAmyDataChanged(() => refreshRef.current()), [])
}
